var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global__search__view" },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModal",
            title: ""
          }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: { namespace: _vm.namespace }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editWhoModal",
            title: "Add / Update Contact"
          },
          on: { shown: _vm.focusUpdateWhoModal }
        },
        [
          _c("UpdateWhoModal", {
            ref: "refUpdateWhoModal",
            attrs: { namespace: _vm.namespace }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editDepartmentModal",
            title: "Add / Update Department"
          },
          on: {
            shown: function($event) {
              return _vm.focusModal("refUpdateDepartmentModal")
            }
          }
        },
        [
          _c("UpdateDepartmentModal", {
            ref: "refUpdateDepartmentModal",
            attrs: {
              departmentData: _vm.departmentData,
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editTagModal",
            title: "Add / Update Tag"
          },
          on: {
            shown: function($event) {
              return _vm.focusModal("refUpdateTagModal")
            }
          }
        },
        [
          _c("UpdateTagModal", {
            ref: "refUpdateTagModal",
            attrs: { tagData: _vm.tagData, namespace: _vm.namespace }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editUserModal",
            title: "Add / Update User"
          },
          on: {
            shown: function($event) {
              return _vm.focusModal("refUpdateUserModal")
            }
          }
        },
        [
          _c("UpdateUserModal", {
            ref: "refUpdateUserModal",
            attrs: { userData: _vm.userData, namespace: _vm.namespace }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("HeaderControls", {
        attrs: {
          GSDataType: _vm.currentTab,
          myWeek: false,
          namespace: _vm.namespace
        },
        on: {
          click: _vm.triggerAddNew,
          click1: _vm.sortData,
          filterUpdated: _vm.filterUpdate,
          collapseToggleUpdated: _vm.collapseToggleUpdate
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "global-search-data-wrapper fixed-top-bar-padding" },
        [
          _c("GlobalSearchHeader", {
            attrs: { currentTab: _vm.currentTab, namespace: _vm.namespace },
            on: { click: _vm.activateTab }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container-fluid" }, [
            _vm.currentTab == "all" &&
            (_vm.globalSearchData.departments.total ||
              _vm.globalSearchData.tags.total ||
              _vm.globalSearchData.coordinators.total ||
              _vm.globalSearchData.contacts.total)
              ? _c("div", { staticClass: "all-title" }, [_vm._m(0)])
              : _vm._e(),
            _vm._v(" "),
            _vm.GSRecentSearch[_vm.currentTab].length > 0 ||
            (_vm.currentTab == "all" &&
              (_vm.GSRecentSearch["all"].length > 0 ||
                _vm.GSRecentSearch["tags"].length > 0 ||
                _vm.GSRecentSearch["contacts"].length > 0 ||
                _vm.GSRecentSearch["coordinators"].length > 0 ||
                _vm.GSRecentSearch["departments"].length > 0))
              ? _c("div", { staticClass: "recent-search summary-wrap" }, [
                  _c("h2", [
                    _vm._m(1),
                    _vm._v("\n            Recent Searches\n            "),
                    _c(
                      "span",
                      {
                        staticClass: "clear-search",
                        on: { click: _vm.clearSearch }
                      },
                      [_vm._v("Clear History")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.currentTab != "all"
                    ? _c(
                        "ul",
                        { staticClass: "search-items" },
                        _vm._l(_vm.GSRecentSearch[_vm.currentTab], function(
                          recentSearch,
                          index
                        ) {
                          return _c("li", {
                            key: index,
                            staticClass: "badge bg-primary mr-2 cursor-pointer",
                            domProps: { textContent: _vm._s(recentSearch) },
                            on: {
                              click: function($event) {
                                return _vm.setSearch(recentSearch)
                              }
                            }
                          })
                        }),
                        0
                      )
                    : _c(
                        "ul",
                        { staticClass: "search-items" },
                        _vm._l(_vm.allRecentSearch, function(
                          recentSearch,
                          index
                        ) {
                          return _c("li", {
                            key: "all" + index,
                            staticClass: "badge bg-primary mr-2 cursor-pointer",
                            domProps: { textContent: _vm._s(recentSearch) },
                            on: {
                              click: function($event) {
                                return _vm.setSearch(recentSearch)
                              }
                            }
                          })
                        }),
                        0
                      )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.globalSearchAll
            ? _c("div", { staticClass: "container-fluid" }, [
                _c("div", {}, [
                  !_vm.globalSearchData.departments.total &&
                  !_vm.globalSearchData.tags.total &&
                  !_vm.globalSearchData.coordinators.total &&
                  !_vm.globalSearchData.contacts.total
                    ? _c("h2", [
                        _vm._v(
                          "No matches found. Please try a different filter."
                        )
                      ])
                    : _c(
                        "div",
                        { staticClass: "d-flex flex-row flex-wrap data-rows" },
                        [
                          _vm.globalSearchData.departments.total > 0
                            ? _c("div", { staticClass: "summary-wrap" }, [
                                _c("h2", { staticClass: "summary-title" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.activateTab("departments")
                                        }
                                      }
                                    },
                                    [
                                      _vm._m(2),
                                      _vm._v(
                                        "\n                  Departments  "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.globalSearchData.departments
                                                  .total
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.globalSearchData.departments.data,
                                    function(data, index) {
                                      return index < 10
                                        ? _c(
                                            "li",
                                            {
                                              key:
                                                "globalSearchDepartmentSummary" +
                                                index,
                                              staticClass: "cursor-pointer",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setDeliverableDepartmentFilter(
                                                    data.id,
                                                    data.title
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary cursor-pointer"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "textInitials"
                                                              )(data.title)
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.userAbilities.editDepartment
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.updateDepartment(
                                                              data
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._m(3, true)]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "department__name cursor-pointer"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(data.title)
                                                      ),
                                                      _c("br")
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Used: " +
                                                        _vm._s(
                                                          data.deliverable_count
                                                        ) +
                                                        " time(s)"
                                                    )
                                                  ])
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "view-all",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.activateTab("departments")
                                      }
                                    }
                                  },
                                  [_vm._v("View All")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.globalSearchData.contacts.total > 0
                            ? _c("div", { staticClass: "summary-wrap" }, [
                                _c("h2", { staticClass: "summary-title" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.activateTab("contacts")
                                        }
                                      }
                                    },
                                    [
                                      _vm._m(4),
                                      _vm._v("\n                  Contacts  "),
                                      _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.globalSearchData.contacts
                                                  .total
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.globalSearchData.contacts.data,
                                    function(data, index) {
                                      return index < 10
                                        ? _c(
                                            "li",
                                            {
                                              key:
                                                "globalSearchContactSummary" +
                                                index,
                                              staticClass: "cursor-pointer",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setDeliverableOutletFilter(
                                                    data
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "textInitials"
                                                              )(
                                                                data.first_name +
                                                                  " " +
                                                                  data.last_name
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "contact__name cursor-pointer"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              data.first_name +
                                                                " " +
                                                                data.last_name
                                                            ) +
                                                            " "
                                                        ),
                                                        data.company_name
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    data.company_name
                                                                  ) +
                                                                  ")"
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _c("br")
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "mailto:" +
                                                            data.email_address
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            data.email_address
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.userAbilities
                                                    .editContact ||
                                                  _vm.userAbilities
                                                    .editMediaCall
                                                    ? _c(
                                                        "a",
                                                        {
                                                          attrs: { href: "#" },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.updateContact(
                                                                data,
                                                                "who"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._m(5, true)]
                                                      )
                                                    : _vm._e()
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "view-all",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.activateTab("contacts")
                                      }
                                    }
                                  },
                                  [_vm._v("View All")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.globalSearchData.coordinators.total > 0
                            ? _c("div", { staticClass: "summary-wrap" }, [
                                _c("h2", { staticClass: "summary-title" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.activateTab("coordinators")
                                        }
                                      }
                                    },
                                    [
                                      _vm._m(6),
                                      _vm._v("\n                  Users  "),
                                      _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.globalSearchData
                                                  .coordinators.total
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.globalSearchData.coordinators.data,
                                    function(data, index) {
                                      return index < 10
                                        ? _c(
                                            "li",
                                            {
                                              key:
                                                "globalSearchCoordinatorSummary" +
                                                index,
                                              staticClass: "cursor-pointer",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setDeliverableCoordinatorFilter(
                                                    data.id,
                                                    data.name
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "textInitials"
                                                              )(data.name)
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.userAbilities.editUser
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.updateUser(
                                                              data
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._m(7, true)]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "coordinator__name cursor-pointer"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(data.name) +
                                                          " " +
                                                          _vm._s(
                                                            !data.is_enabled
                                                              ? "(archived)"
                                                              : ""
                                                          )
                                                      ),
                                                      _c("br")
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "mailto:" + data.email
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        }
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(data.email))]
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "view-all",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.activateTab("coordinators")
                                      }
                                    }
                                  },
                                  [_vm._v("View All")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.globalSearchData.tags.total > 0
                            ? _c("div", { staticClass: "summary-wrap" }, [
                                _c("h2", { staticClass: "summary-title" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.activateTab("tags")
                                        }
                                      }
                                    },
                                    [
                                      _vm._m(8),
                                      _vm._v("\n                  Tags "),
                                      _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.globalSearchData.tags.total
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.globalSearchData.tags.data,
                                    function(data, index) {
                                      return index < 10
                                        ? _c(
                                            "li",
                                            {
                                              key:
                                                "globalSearchTagSummary" +
                                                index,
                                              staticClass: "cursor-pointer",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setDeliverableTagFilter(
                                                    data.id,
                                                    data.tag
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("div", [
                                                _vm._m(9, true),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tag__name cursor-pointer"
                                                    },
                                                    [
                                                      _vm._v(_vm._s(data.tag)),
                                                      _c("br")
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Used: " +
                                                        _vm._s(
                                                          data.deliverable_count
                                                        ) +
                                                        " time(s)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.userAbilities.editTag
                                                    ? _c(
                                                        "a",
                                                        {
                                                          attrs: { href: "#" },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.updateTag(
                                                                data
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._m(10, true)]
                                                      )
                                                    : _vm._e()
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "view-all",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        return _vm.activateTab("tags")
                                      }
                                    }
                                  },
                                  [_vm._v("View All")]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.globalSearchDepartments
            ? _c("div", { staticClass: "container-fluid" }, [
                _c(
                  "div",
                  { staticClass: "global-search-listing" },
                  [
                    _c("h2", [
                      _c(
                        "span",
                        {
                          staticClass: "title-icon",
                          class:
                            !_vm.userAbilities.createDepartment &&
                            !_vm.userAbilities.editMediaCall
                              ? "pointer-default"
                              : "",
                          on: {
                            click: function($event) {
                              _vm.userAbilities.createDepartment ||
                              _vm.userAbilities.editMediaCall
                                ? _vm.updateDepartment("")
                                : ""
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-project-diagram" }),
                          _vm._v(" "),
                          _vm.userAbilities.createDepartment ||
                          _vm.userAbilities.editMediaCall
                            ? _c("span", { staticClass: "add-item-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/csmworkflow/img/add-icon.svg")
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v("\n            Departments  "),
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v(
                          "(" +
                            _vm._s(_vm.globalSearchData.departments.total) +
                            ")"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-card-group",
                      { attrs: { deck: "" } },
                      [
                        _vm._l(_vm.globalSearchData.departments.data, function(
                          data,
                          index
                        ) {
                          return _vm.globalSearchData.departments.total > 0
                            ? _c(
                                "b-card",
                                {
                                  key: "globalSearchDepartmentSummary" + index,
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.setDeliverableDepartmentFilter(
                                        data.id,
                                        data.title
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function() {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                staticClass:
                                                  "float-left truncate-text",
                                                attrs: { title: data.title }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "textInitials"
                                                              )(data.title)
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "department__name cursor-pointer"
                                                  },
                                                  [_vm._v(_vm._s(data.title))]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.userAbilities.editDepartment
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass: "float-right",
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.updateDepartment(
                                                          data
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "edit-contact"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-edit"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "b-card-text",
                                    { staticClass: "card-detail__gs" },
                                    [
                                      _vm._v(
                                        "\n                Used: " +
                                          _vm._s(data.deliverable_count) +
                                          " time(s)\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm.globalSearchData.departments.total == 0
                          ? _c("h2", { staticClass: "ml-3" }, [
                              _vm._v(
                                "\n              No matches found. Please try a different filter.\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.globalSearchData.departments
                      ? _c(
                          "div",
                          { staticClass: "pagination-wrapper" },
                          [
                            _c("pagination", {
                              attrs: {
                                data: _vm.globalSearchData.departments,
                                limit: 5
                              },
                              on: {
                                "pagination-change-page":
                                  _vm.onPageChangeDepartments
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.globalSearchTags
            ? _c("div", { staticClass: "container-fluid" }, [
                _c(
                  "div",
                  { staticClass: "global-search-listing" },
                  [
                    _c("h2", [
                      _c(
                        "span",
                        {
                          staticClass: "title-icon",
                          class:
                            !_vm.userAbilities.createTag &&
                            !_vm.userAbilities.editMediaCall
                              ? "pointer-default"
                              : "",
                          on: {
                            click: function($event) {
                              _vm.userAbilities.createTag ||
                              _vm.userAbilities.editMediaCall
                                ? _vm.updateTag("")
                                : ""
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-hashtag" }),
                          _vm._v(" "),
                          _vm.userAbilities.createTag ||
                          _vm.userAbilities.editMediaCall
                            ? _c("span", { staticClass: "add-item-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/csmworkflow/img/add-icon.svg")
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v("\n            Tags  "),
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v(
                          "(" + _vm._s(_vm.globalSearchData.tags.total) + ")"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-card-group",
                      { attrs: { deck: "" } },
                      [
                        _vm._l(_vm.globalSearchData.tags.data, function(
                          data,
                          index
                        ) {
                          return _vm.globalSearchData.tags.total > 0
                            ? _c(
                                "b-card",
                                {
                                  key: "globalSearchTagSummary" + index,
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.setDeliverableTagFilter(
                                        data.id,
                                        data.tag
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function() {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "float-left truncate-text"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-hashtag"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tag__name cursor-pointer"
                                                  },
                                                  [_vm._v(_vm._s(data.tag))]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.userAbilities.editTag
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass: "float-right",
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.updateTag(
                                                          data
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "edit-contact"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-edit"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "b-card-text",
                                    { staticClass: "card-detail__gs" },
                                    [
                                      _vm._v(
                                        "\n                Used: " +
                                          _vm._s(data.deliverable_count) +
                                          " time(s)\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm.globalSearchData.tags.total == 0
                          ? _c("h2", { staticClass: "ml-3" }, [
                              _vm._v(
                                "\n              No matches found. Please try a different filter.\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.globalSearchData.tags
                      ? _c(
                          "div",
                          { staticClass: "pagination-wrapper" },
                          [
                            _c("pagination", {
                              attrs: {
                                data: _vm.globalSearchData.tags,
                                limit: 5
                              },
                              on: {
                                "pagination-change-page": _vm.onPageChangeTags
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.globalSearchContacts
            ? _c("div", { staticClass: "container-fluid" }, [
                _c(
                  "div",
                  { staticClass: "global-search-listing" },
                  [
                    _c("h2", [
                      _c(
                        "span",
                        {
                          staticClass: "title-icon",
                          class:
                            !_vm.userAbilities.createContact &&
                            !_vm.userAbilities.editMediaCall
                              ? "pointer-default"
                              : "",
                          on: {
                            click: function($event) {
                              _vm.userAbilities.createContact ||
                              _vm.userAbilities.editMediaCall
                                ? _vm.updateContact("")
                                : ""
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "far fa-id-badge" }),
                          _vm._v(" "),
                          _vm.userAbilities.createContact ||
                          _vm.userAbilities.editMediaCall
                            ? _c("span", { staticClass: "add-item-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/csmworkflow/img/add-icon.svg")
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v("\n            Contacts  "),
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v(
                          "(" +
                            _vm._s(_vm.globalSearchData.contacts.total) +
                            ")"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-card-group",
                      { attrs: { deck: "" } },
                      [
                        _vm._l(_vm.globalSearchData.contacts.data, function(
                          data,
                          index
                        ) {
                          return _vm.globalSearchData.contacts.total > 0
                            ? _c(
                                "b-card",
                                {
                                  key: "globalSearchContactSummary" + index,
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.setDeliverableOutletFilter(
                                        data
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function() {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                staticClass:
                                                  "float-left truncate-text",
                                                attrs: {
                                                  title:
                                                    data.first_name +
                                                    " " +
                                                    data.last_name
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "textInitials"
                                                              )(
                                                                data.first_name +
                                                                  " " +
                                                                  data.last_name
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "contact__name cursor-pointer"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.first_name +
                                                          " " +
                                                          data.last_name
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.userAbilities.editContact ||
                                            _vm.userAbilities.editMediaCall
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass: "float-right",
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.updateContact(
                                                          data,
                                                          "who"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "edit-contact"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-edit"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "b-card-text",
                                    { staticClass: "card-detail__gs" },
                                    [
                                      data.company_name
                                        ? _c(
                                            "div",
                                            { staticClass: "contact__name" },
                                            [_vm._v(_vm._s(data.company_name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.email_address
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "mailto:" + data.email_address
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(data.email_address))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.cell_phone
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "tel:" +
                                                  data.cell_phone.replace(
                                                    /\D/g,
                                                    ""
                                                  )
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(data.cell_phone))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.phone
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "tel:" +
                                                  data.phone.replace(/\D/g, "")
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(data.phone))]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm.globalSearchData.contacts.total == 0
                          ? _c("h2", { staticClass: "ml-3" }, [
                              _vm._v(
                                "\n              No matches found. Please try a different filter.\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.globalSearchData.contacts
                      ? _c(
                          "div",
                          { staticClass: "pagination-wrapper" },
                          [
                            _c("pagination", {
                              attrs: {
                                data: _vm.globalSearchData.contacts,
                                limit: 5
                              },
                              on: {
                                "pagination-change-page":
                                  _vm.onPageChangeContacts
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.globalSearchCoordinators
            ? _c("div", { staticClass: "container-fluid" }, [
                _c(
                  "div",
                  { staticClass: "global-search-listing" },
                  [
                    _c("h2", [
                      _c(
                        "span",
                        {
                          staticClass: "title-icon",
                          class: !_vm.userAbilities.createUser
                            ? "pointer-default"
                            : "",
                          on: {
                            click: function($event) {
                              _vm.userAbilities.createUser
                                ? _vm.updateUser("")
                                : ""
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "far fa-user-circle" }),
                          _vm._v(" "),
                          _vm.userAbilities.createUser
                            ? _c("span", { staticClass: "add-item-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/csmworkflow/img/add-icon.svg")
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v("\n            Users  "),
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v(
                          "(" +
                            _vm._s(_vm.globalSearchData.coordinators.total) +
                            ")"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.userAbilities.roleManager
                        ? _c(
                            "div",
                            { staticClass: "float-md-right mt-3 mt-md-0" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "header-filter-btns",
                                  attrs: { variant: "theme" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push(
                                        "permission-manager"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Permission Manager "
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "fas fa-user-lock text-primary fa-fw float-right ml-2"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-card-group",
                      { attrs: { deck: "" } },
                      [
                        _vm._l(_vm.globalSearchData.coordinators.data, function(
                          data,
                          index
                        ) {
                          return _vm.globalSearchData.coordinators.total > 0
                            ? _c(
                                "b-card",
                                {
                                  key: "globalSearchCoordinatorSummary" + index,
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.setDeliverableCoordinatorFilter(
                                        data.id,
                                        data.name
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function() {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                staticClass:
                                                  "float-left truncate-text",
                                                attrs: { title: data.name }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "info-bubbles"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "initials badge badge-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "textInitials"
                                                              )(data.name)
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "coordinator__name cursor-pointer"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(data.name) +
                                                        " " +
                                                        _vm._s(
                                                          !data.is_enabled
                                                            ? "(archived)"
                                                            : ""
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.userAbilities.editUser
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass: "float-right",
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.updateUser(
                                                          data
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "edit-contact"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-edit"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "b-card-text",
                                    { staticClass: "card-detail__gs" },
                                    [
                                      data.email
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "mailto:" + data.email
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(data.email))]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm.globalSearchData.coordinators.total == 0
                          ? _c("h2", { staticClass: "ml-3" }, [
                              _vm._v(
                                "\n              No matches found. Please try a different filter.\n            "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.globalSearchData.coordinators
                      ? _c(
                          "div",
                          { staticClass: "pagination-wrapper" },
                          [
                            _c("pagination", {
                              attrs: {
                                data: _vm.globalSearchData.coordinators,
                                limit: 5
                              },
                              on: {
                                "pagination-change-page":
                                  _vm.onPageChangeCoordinators
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("span", { staticClass: "pointer-default title-icon" }, [
        _c("i", { staticClass: "far fa-clock" })
      ]),
      _vm._v("\n            Most Recent\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-icon" }, [
      _c("i", { staticClass: "fas fa-history" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-icon" }, [
      _c("i", { staticClass: "fas fa-project-diagram" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "edit-contact" }, [
      _c("i", { staticClass: "fas fa-edit" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-icon" }, [
      _c("i", { staticClass: "far fa-id-badge" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "edit-contact" }, [
      _c("i", { staticClass: "fas fa-edit" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-icon" }, [
      _c("i", { staticClass: "far fa-user-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "edit-contact" }, [
      _c("i", { staticClass: "fas fa-edit" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-icon" }, [
      _c("i", { staticClass: "fas fa-hashtag" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "info-bubbles" }, [
      _c("span", { staticClass: "initials badge badge-primary" }, [
        _c("i", { staticClass: "fas fa-hashtag" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "edit-contact" }, [
      _c("i", { staticClass: "fas fa-edit" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }